import { Component, EventEmitter, Inject, Input, OnInit, Output } from '@angular/core'

@Component({
  selector: 'dmmp-maps',
  templateUrl: './maps.component.html'
})
export class MapsComponent implements OnInit {

  @Input() mapConfig: any
  @Input() marks: Array<any>
  @Input() type
  @Input() mapClass
  @Input() mode

  @Output() markerClickEmitter: EventEmitter<any> = new EventEmitter()

  constructor(@Inject('ENV') public env) { }

  ngOnInit(): void {
  }

  markerClick(clickInfo) {
    this.markerClickEmitter.emit(clickInfo)
  }

}
